import angular from 'angular';
import hubChooserComponent from './hubChooserComponent';

angular.module('sh.hubChooser', []).directive('shHubChooser', hubChooserComponent);
